import React, { useEffect, useState } from 'react';
import { Button as MIButton } from '@material-ui/core';
import { connect } from 'react-redux';
import styles from './expenses-list.module.scss';
import DeleteIcon from '@material-ui/icons/Delete';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import { Expenses } from '../../../shared/models/unit-types.model';
import {
  CreateExpenseModal,
  CreateExpenses
} from './components/create-reservation/create-expense-modal.component';
import Button, { ButtonSize } from '../../../shared/components/core-ui/button/button.component';
import { RootState } from '../../../shared/redux/reducers';
import { createExpenses, deleteExpense, getExpenses } from '../../shared/services/data.service';
import { isErrorInfo } from '../../../shared/interfaces/error-info.interface';
import DownloadIcon from '@material-ui/icons/CloudDownload';

import { ExpensesPayoutListFilterContainer } from '../../../shared/components/widgets/expenses-payout-list-filter/expenses-payout-list-filter.component';
import { Pagination } from '../../../shared/components/core-ui/pagination/pagination.component';

export type ExpensesListCoContainerProps = ReturnType<typeof mapStateToProps>;

/**
 * functional component ReservationsListContainer
 * @param {ExpensesListCoContainerProps} holding question text
 */
export const ExpensesListContainer: React.FC<ExpensesListCoContainerProps> = () => {
  const [showCreateReseration, setShowCreateReseration] = useState<boolean>(false);
  const [expenses, setExpenses] = useState<Expenses[]>([]);
  const [listCount, setListCount] = useState<number>(0);
  const [offset, setOffset] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [searchQuery, setSearchQuery] = useState<Record<string, unknown>>({});

  const searchExpenses = (filteredData: {
    room: string;
    description: string;
    project: string;
    area: string;
    category: string;
    paymentDateFrom: Date;
    paymentDateTo: Date;
    amount: string;
  }) => {
    setSearchQuery(filteredData);
    setOffset(1);
    getExpensesList(filteredData, 1, limit);
  };

  useEffect(() => {
    getExpensesList({}, 1, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getExpensesList = (query: Record<string, unknown>, page: number, pageSize: number) => {
    getExpenses({ ...query, offset: page, limit: pageSize }).then((response) => {
      if (!isErrorInfo(response)) {
        if (typeof response === 'object' && 'expenses' in response) {
          setExpenses(response.expenses);
          setListCount(response.count);
        }
      }
    });
  };

  const downloadCSV = (file: Blob | string) => {
    const link = document.createElement('a');
    const csvBlob = file instanceof Blob ? file : new Blob([file], { type: 'text/csv' });
    link.href = window.URL.createObjectURL(csvBlob);
    link.setAttribute('download', 'expenses.csv');
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
  };

  const exportExpenses = () => {
    getExpenses({ ...searchQuery, isExport: true }).then((response) => {
      if (!isErrorInfo(response) && (response instanceof Blob || typeof response === 'string')) {
        downloadCSV(response);
      }
    });
  };
  const addExpenseHandler = (expense: CreateExpenses) => {
    // createExpenses(expense).then((response) => {
    //   uploadExpense(response?.data?.id, expense?.file).then(() => {
    //     console.log(response.data);
    //     getExpensesList({});
    //   });
    // });
    createExpenses(expense, expense.file).then((response) => {
      if (!isErrorInfo(response)) {
        getExpensesList(searchQuery, offset, limit);
      }
    });
  };
  const deleteExpenseHandler = (expense: Expenses) => {
    deleteExpense(expense.id).then(() => {
      getExpensesList(searchQuery, offset, limit);
    });
  };

  function Row(props: { expense: Expenses }) {
    const { expense } = props;
    return (
      <>
        <TableRow>
          <TableCell>
            <MIButton
              aria-haspopup="true"
              onClick={() => {
                deleteExpenseHandler(expense);
              }}
            >
              <DeleteIcon fontSize={'large'} color="inherit" />
            </MIButton>
          </TableCell>
          <TableCell>{expense?.description}</TableCell>
          <TableCell>{expense?.roomName}</TableCell>
          <TableCell>{expense?.projectName}</TableCell>
          <TableCell>{expense?.areaName}</TableCell>
          <TableCell> {moment(expense.paymentDate).format('MM/DD/YYYY')}</TableCell>
          <TableCell>{expense?.category}</TableCell>
          <TableCell>{expense?.amount}</TableCell>
          <TableCell>{expense.updateByUser}</TableCell>
          <TableCell>
            <div style={{ display: 'flex' }}>
              {/* <MIButton
                aria-haspopup="true"
                onClick={() => {
                  //deletePayoutHandler(payout);
                }}
              >
                <DeleteIcon fontSize={'large'} color="inherit" />
              </MIButton> */}
              {expense.expensesReceipt?.receiptUrl && (
                <MIButton aria-haspopup="true">
                  <a href={expense.expensesReceipt?.receiptUrl}>
                    <DownloadIcon fontSize={'large'} color="inherit" />
                  </a>
                </MIButton>
              )}
            </div>
          </TableCell>
        </TableRow>
        <TableRow></TableRow>
      </>
    );
  }
  return (
    <div className={styles['expense-list-container']}>
      <CreateExpenseModal
        config={{
          showModal: showCreateReseration
        }}
        eventHandlers={{
          closeHandler: () => {
            setShowCreateReseration(false);
          },
          addExpenseHandler: (expense) => {
            setShowCreateReseration(false);
            addExpenseHandler(expense);
          }
        }}
      ></CreateExpenseModal>
      <div className={styles['expense-list-container__title']}>
        <span className="text-4xl font-recoleta font-semibold text-neutral-500">Expenses</span>
        <div className={styles['expense-list-container__title__actions']}>
          <Button
            onClick={exportExpenses}
            tracking={{ event: 'report_exported', report: 'expenses' }}
            size={ButtonSize.medium}
          >
            Export
          </Button>
          <Button
            onClick={() => {
              setShowCreateReseration(true);
            }}
            tracking={{ event: 'record_edit_started', entity: 'expense' }}
            size={ButtonSize.medium}
          >
            Create Expense
          </Button>
        </div>
      </div>
      <ExpensesPayoutListFilterContainer
        data={expenses}
        eventHandlers={{
          search: (data: {
            room: string;
            description: string;
            project: string;
            area: string;
            category: string;
            paymentDateFrom: Date;
            paymentDateTo: Date;
            amount: string;
          }) => searchExpenses(data),
          getInitialList: () => {
            setSearchQuery({});
            setOffset(1);
            getExpensesList({}, 1, limit);
          }
        }}
      />

      <TableContainer component={Paper}>
        <Table aria-label="table">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>description</TableCell>
              <TableCell>room Name</TableCell>
              <TableCell>project Name</TableCell>
              <TableCell>Area Name</TableCell>
              <TableCell>paymentDate</TableCell>
              <TableCell>category</TableCell>
              <TableCell>amount</TableCell>
              <TableCell>updated By</TableCell>
              <TableCell>attachment</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {expenses?.map((expense) => (
              <Row key={expense.id} expense={expense} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {listCount > 0 && (
        <Pagination
          itemCounts={listCount}
          itemsPerPage={limit}
          offset={offset}
          handlePageChange={(page) => {
            setOffset(page);
            getExpensesList(searchQuery, page, limit);
          }}
          handleItemsPerPage={(itemsPerPage) => {
            setLimit(itemsPerPage);
            setOffset(1);
            getExpensesList(searchQuery, 1, itemsPerPage);
          }}
        />
      )}
    </div>
  );
};

export default connect(mapStateToProps)(ExpensesListContainer);

/**
 * function to to map redux state to component props
 * @param state root state or redux
 */
function mapStateToProps(state: RootState) {
  return {
    isAuthenticated: !!state.auth.accessToken
  };
}
